var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMortgageAndRent = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Real-Estate-Action-House-Dollar--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Real Estate Action House Dollar Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 17.5a8 8 0 0 1 13.14 -6.12 0.47 0.47 0 0 0 0.32 0.12h0.54a0.5 0.5 0 0 0 0.34 -0.86L13 0.41a1.5 1.5 0 0 0 -2 0L0.16 10.64a0.5 0.5 0 0 0 0.34 0.86h2a0.5 0.5 0 0 1 0.5 0.5v10a1 1 0 0 0 1 1h6.64a0.5 0.5 0 0 0 0.4 -0.8 7.9 7.9 0 0 1 -1.54 -4.7Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 11a6.5 6.5 0 1 0 6.5 6.5 6.51 6.51 0 0 0 -6.5 -6.5Zm1.11 10.16a0.5 0.5 0 0 0 -0.36 0.48v0.11a0.75 0.75 0 0 1 -1.5 0 0.5 0.5 0 0 0 -0.5 -0.5H16a0.75 0.75 0 0 1 0 -1.5h2a0.59 0.59 0 0 0 0.59 -0.59 0.58 0.58 0 0 0 -0.37 -0.55l-2.06 -0.83a2.08 2.08 0 0 1 0.2 -3.94 0.5 0.5 0 0 0 0.36 -0.48v-0.11a0.75 0.75 0 0 1 1.5 0 0.5 0.5 0 0 0 0.5 0.5H19a0.75 0.75 0 0 1 0 1.5h-2a0.59 0.59 0 0 0 -0.22 1.14l2.06 0.83a2.06 2.06 0 0 1 1.31 1.94 2.08 2.08 0 0 1 -1.54 2Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMortgageAndRent);
export default ForwardRef;